import { store, itiHttpService} from '@/iti-core-vue';
import { Action, getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { API } from '@/shared/api';
import { Evento } from '@/shared/dtos/evento';

@Module({
  namespaced: true,
  name: 'EventModule',
  store,
  dynamic: true,
})
class EventModule extends VuexModule {

    public nextEvents: Evento[] = [];    

    @Mutation
    public setNextEventsFromUser(nextEvents: Evento[]) {
        this.nextEvents = nextEvents;
    }

    @Action
    public async getNextEventsFromUser() {
        const res = await itiHttpService.get(API.event + '/GetNextEventsFromUser');
        this.context.commit('setNextEventsFromUser', res);
    }

    @Mutation
    public setNextEventsFromUserByAreaType(nextEvents: Evento[]) {
        this.nextEvents = nextEvents;
    }

    @Action
    public async getNextEventsFromUserByAreaType(type: number) {
        const res = await itiHttpService.get(API.event + '/GetNextEventsFromUserByAreaType?typeId=' + type);
        this.context.commit('setNextEventsFromUserByAreaType', res);
    }
    
    @Mutation
    public setNextEventsByAmbitId(nextEvents: Evento[]) {
        this.nextEvents = nextEvents;
    }

    @Action
    public async getNextEventsByAmbitId(ambitId: number) {
        const res = await itiHttpService.get(API.event + '/GetNextEventsByAmbitId?ambitId=' + ambitId);
        this.context.commit('setNextEventsByAmbitId', res);
    }

}
export default getModule(EventModule);
